import React, { useEffect, useState } from 'react';

interface IProps {
    children: any;
    modifiers?: string | string[];
}

/**
 * @description Place inside of HanTable.tsx
 * @param children The content of a table row. Place the component HanTableCell.tsx in here as many times as needed.
 * @param modifiers Possible modifiers:
 * - alabaster
 * - black
 * - border-top
 *
 * Border
 *      - border-none
 */
const HanTableRow: React.FC<IProps> = ({ children, modifiers }) => {
    const baseClassName = "han-table__row";
    const [className, setClassName] = useState<string>(baseClassName);

    useEffect(() => {
        if(modifiers) {
            let classNameString = baseClassName;

            if(Array.isArray(modifiers)) {
                modifiers.forEach(modifier => {
                    classNameString += ` ${baseClassName}--${modifier}`;
                })
            } else {
                classNameString += ` ${baseClassName}--${modifiers}`;
            }
            
            setClassName(classNameString);
        }
    }, [modifiers])

    return (
        <tr className={className}>
            {children}
        </tr>
    )
}

export default HanTableRow;
